// Feature flag names are inlined as string literals (rather than Features.X.name)
// so this module can be imported under sparse Features mocks in unit tests.
export const consumptionEntitlementToFeatureFlagNameMap: Record<string, string> = {
    'APICALLS': 'EnableApiCallsUsage',
    'TransportUnits': 'EnableTransportUnitsUsage',
    'IntegrationActivities': 'EnableIntegrationActivitiesUsage',
};

export const predefinedConsumptionEntitlements = Object.keys(consumptionEntitlementToFeatureFlagNameMap);
